import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCampground,faEnvelope} from '@fortawesome/free-solid-svg-icons';
import {faLinkedin,faGithub, faPinterest, faCodepen,faReact, faCss3, faDocker,faJira, faAws,faBootstrap,
        faHtml5,faJs,faNode,faSass } from '@fortawesome/free-brands-svg-icons';

let campground = <FontAwesomeIcon icon={faCampground} size="2x"/>;

let pinterest = <FontAwesomeIcon icon={faPinterest} size="3x" />;
let linkedIn = <FontAwesomeIcon icon={faLinkedin} size="3x"/>;
let gitHub = <FontAwesomeIcon icon={faGithub} size="3x"/>;
let codePen = <FontAwesomeIcon icon={faCodepen} size="3x"/>;
let gmail = <FontAwesomeIcon icon={faEnvelope} size="3x"/>;

let react = <FontAwesomeIcon icon={faReact} size="2x"/>;
let css3 = <FontAwesomeIcon icon={faCss3} size="2x"/>;
let docker = <FontAwesomeIcon icon={faDocker} size="2x"/>;
let jira = <FontAwesomeIcon icon={faJira} size="2x"/>;
let aws = <FontAwesomeIcon icon={faAws} size="2x"/>;
let bootstrap = <FontAwesomeIcon icon={faBootstrap} size="2x"/>;
let html5 = <FontAwesomeIcon icon={faHtml5} size="2x"/>;
let js = <FontAwesomeIcon icon={faJs} size="2x"/>;
let node = <FontAwesomeIcon icon={faNode} size="2x"/>;
let sass = <FontAwesomeIcon icon={faSass} size="2x"/>;


export {campground, gitHub, linkedIn,pinterest,codePen, gmail,react, css3, docker,jira, aws,bootstrap, html5,
js, node,sass};


